import React, { ChangeEvent } from "react";
import {
    Button,
    CircularProgress,
    createStyles,
    Divider,
    FormControlLabel,
    FormHelperText,
    Grid,
    Paper,
    Switch,
    Tab,
    Tabs,
    TextField,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { AddCircleOutline, Delete, OpenInNew, Save } from "@material-ui/icons";
import $ from "jquery";
import { enqueueSnackbar } from "notistack";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { Link, LinkProps } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Temporal } from "temporal-polyfill";
import FileApi from "../../../../api/FileApi";
import {
    DateTimeLocalFormat,
    parseAuctionInstant,
    skippedOrRepeatedTimeMessage,
    toInstant,
    toWallTime,
    visitorTimeZone
} from "../../../../helpers/auctionDateTime";
import { slugify } from "../../../../helpers/format";
import IErrorInfo from "../../../../models/account/IErrorInfo";
import IAuctionDetail from "../../../../models/auction/IAuctionDetail";
import ICreateUpdateAuction from "../../../../models/auction/ICreateUpdateAuction";
import { FileType } from "../../../../models/files/FileType";
import IFileMetadata from "../../../../models/files/IFileMetadata";
import * as Roles from "../../../../models/security/Roles";
import Constants from "../../../../models/utility/Constants";
import { LoadState } from "../../../../models/utility/LoadState";
import { userHasRole } from "../../../../providers/SecurityProvider";
import { IAppDispatch, IAppState } from "../../../../store";
import * as AppConfigStore from "../../../../store/AppConfigStore";
import * as AuctionStore from "../../../../store/AuctionStore";
import * as ParcelStore from "../../../../store/ParcelStore";
import * as UserStore from "../../../../store/UserStore";
import FullscreenLoader from "../../../layout/FullscreenLoader";
import AuditTimestamps from "../../../shared/admin/AuditTimestamps";
import LiveClosedNotice from "../../../shared/admin/LiveClosedNotice";
import ParcelEditContainer from "../../../shared/admin/ParcelEditContainer";
import ParcelsOrderRow from "../../../shared/admin/ParcelsOrderRow";
import BannerButton from "../../../shared/BannerButton";
import DateTimePicker from "../../../shared/DateTimePicker";
import FormErrorWrapper from "../../../shared/FormErrorWrapper";
import LoaderButton from "../../../shared/LoaderButton";
import SectionBanner from "../../../shared/SectionBanner";
import ApprovedAuctionBiddersTab from "./ApprovedAuctionBiddersTab";
import AuctionRemindersTab from "./AuctionRemindersTab";
import AuctionSavedSearchSendTab from "./AuctionSavedSearchSendTab";
import AuctionWatchersTab from "./AuctionWatchersTab";
import { parseSaleDetailsTab, withSaleDetailsTab } from "./saleDetailsTabs";

type ManageAuctionDetailsProps = AuctionStore.IAuctionStoreState &
    typeof AuctionStore.actionCreators &
    ParcelStore.IParcelStoreState &
    typeof ParcelStore.actionCreators &
    UserStore.IUserStoreState &
    typeof UserStore.actionCreators &
    AppConfigStore.IAppConfigStoreState &
    WithStyles<typeof styles> &
    RouteComponentProps<{ url: string }>;

interface IManageAuctionDetailsState {
    createUpdateAuction: ICreateUpdateAuction;
    deleteClicked: boolean;
    isCreate: boolean;
    newParcel: boolean;
    isAuctionDateValid: boolean;
    formErrors: IErrorInfo[];
    pictureErrors: IErrorInfo[];
    redirectUrl: string;
    selectedTab: number;
    submittedUrl: string;
    synchedStartTimeValue: Temporal.PlainDateTime | null;
    isSyncedStartTimeValid: boolean;
    syncedStartTimeSkippedMessage: string | null;
    synchedCloseTimeValue: Temporal.PlainDateTime | null;
    isSyncedCloseTimeValid: boolean;
    syncedCloseTimeSkippedMessage: string | null;
    urlManuallyEdited: boolean;
}
const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const styles = (theme: Theme) =>
    createStyles({
        auditWrapper: { marginTop: theme.spacing(0.5) },
        buttonCreateNew: { float: "right", backgroundColor: "white" },
        carouselWrapper: {
            display: "flex",
            justifyContent: "center",
            marginTop: theme.spacing(3),
            maxHeight: 450,
            position: "relative",
            width: "100%"
        },
        deleteButton: {
            "&:hover": { backgroundColor: theme.palette.error.dark },
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            marginLeft: theme.spacing(2)
        },
        divider: { marginTop: theme.spacing(4) },
        editorLabel: { marginBottom: theme.spacing(1.25) },
        form: { width: "100%" },
        formSection: {
            marginBottom: theme.spacing(5),
            backgroundColor: "#000000",
            padding: "32px"
        },
        formSyncedSection: { marginTop: theme.spacing(5) },
        hidden: { display: "none" },
        image: {
            height: "auto",
            maxHeight: 450,
            maxWidth: "100%",
            width: "auto"
        },
        imageDelete: {
            padding: theme.spacing(),
            position: "absolute",
            right: 0,
            top: 0
        },
        imageDeleteBtn: {
            "&:hover": { color: theme.palette.error.main },
            color: theme.palette.common.white,
            padding: 0
        },
        imageDeleteIcon: {
            filter: "drop-shadow(2px 2px 2px black)",
            msFilter: "drop-shadow(2px 2px 2px black)",
            webkitFilter: "drop-shadow(2px 2px 2px black)"
        },
        imageWrapper: { position: "relative" },
        paper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column"
        },
        parcelLoader: { margin: theme.spacing(3) },
        parcelLoaderWrapper: {
            alignItems: "center",
            display: "flex",
            height: 200,
            justifyContent: "center",
            width: "100%"
        },
        viewBiddingButton: {
            marginLeft: theme.spacing(2)
        },
        sendNotificationsButton: {
            marginLeft: theme.spacing(2)
        },
        section: {
            [theme.breakpoints.down("xs")]: {
                paddingLeft: theme.bodyContent.mobilePadding,
                paddingRight: theme.bodyContent.mobilePadding
            },
            backgroundColor: theme.palette.background.paper,
            paddingLeft: theme.bodyContent.desktopPadding,
            paddingRight: theme.bodyContent.desktopPadding,
            position: "relative",
            width: "100%"
        },
        sectionContent: {
            [theme.breakpoints.down("xs")]: {
                paddingLeft: theme.bodyContent.mobilePadding,
                paddingRight: theme.bodyContent.mobilePadding
            },
            margin: "0 auto",
            maxWidth: theme.bodyContent.maxWidth,
            paddingBottom: theme.bodyContent.desktopPadding,
            paddingTop: theme.bodyContent.desktopPadding,
            width: "100%"
        },
        uploadWrapper: { marginTop: theme.spacing() }
    });

class ManageAuctionDetails extends React.PureComponent<
    ManageAuctionDetailsProps,
    IManageAuctionDetailsState
> {
    constructor(props: ManageAuctionDetailsProps) {
        super(props);

        const createUpdateAuction: ICreateUpdateAuction = {
            draftMode: true,
            name: "",
            url: "",
            isApprovalRequired: false,
            approvedAuctionBidderUserIds: [],
            isSynchronized: true,
            synchronizedStartTime: "",
            synchronizedCloseTime: "",
            isTest: false
        };
        const isCreate =
            this.props.match.params.url === Constants.UrlCreateAuction;

        this.state = {
            createUpdateAuction,
            deleteClicked: false,
            formErrors: [],
            isAuctionDateValid: true,
            synchedStartTimeValue: null,
            isSyncedStartTimeValid: true,
            syncedStartTimeSkippedMessage: null,
            synchedCloseTimeValue: null,
            isSyncedCloseTimeValid: true,
            syncedCloseTimeSkippedMessage: null,
            isCreate,
            newParcel: false,
            pictureErrors: [],
            redirectUrl: "",
            selectedTab: parseSaleDetailsTab(
                this.props.location.search,
                isCreate
            ),
            submittedUrl: "",
            urlManuallyEdited: !isCreate
        };
    }

    public componentDidMount() {
        this.props.resetAuctionSaveErrors();

        if (this.props.match.params.url !== Constants.UrlCreateAuction) {
            this.props.loadAuctionDetail(this.props.match.params.url);
            this.props.loadParcelList(this.props.match.params.url);
        } else {
            this.props.toggleAuctionLoadState(LoadState.Loaded);
        }
    }

    public componentWillUnmount() {
        this.props.clearAuctionDetail();
    }

    public componentDidUpdate(prevProps: ManageAuctionDetailsProps) {
        // scroll to top if there are new error messages
        if (
            (this.props.savingAuctionErrors !== prevProps.savingAuctionErrors &&
                this.props.savingAuctionErrors.length > 0) ||
            this.state.formErrors.length > 0
        ) {
            $("body, html").animate(
                { scrollTop: 0 },
                Constants.ScrollAnimationLength
            );
        }

        // Show snackbar if save was successful
        if (
            prevProps.savingAuction &&
            !this.props.savingAuction &&
            this.props.savingAuctionErrors.length === 0
        ) {
            if (this.state.deleteClicked) {
                this.openErrorSnackbar();
            } else {
                // Reload the auction details (using the saved URL) so the View Bidding link and LiveClosedNotice reflect the saved values
                if (!this.state.isCreate) {
                    this.props.loadAuctionDetail(this.state.submittedUrl);
                }
                this.openSuccessSnackbar();
            }

            // redirect to saved auction if this was new creation
            if (this.state.isCreate) {
                this.setState({
                    redirectUrl: Constants.Routes.AdminAuctionDetail(
                        this.state.submittedUrl
                    )
                });
            } else if (this.state.deleteClicked) {
                this.setState({
                    redirectUrl: Constants.Routes.AdminAuctionList()
                });
            }

            return;
        } else if (
            this.props.savingAuctionErrors.length > 0 &&
            (this.state.deleteClicked || this.state.redirectUrl)
        ) {
            this.setState({ deleteClicked: false, redirectUrl: "" });
            return;
        }

        // clear new parcel box if successful
        if (
            prevProps.savingNewParcel &&
            !this.props.savingNewParcel &&
            (!this.props.savingNewParcelErrors ||
                this.props.savingNewParcelErrors.length === 0)
        ) {
            this.setState({ newParcel: false });
        }

        if (
            this.state.createUpdateAuction.isSynchronized &&
            !this.state.synchedStartTimeValue
        ) {
            const now = Temporal.Now.instant();
            const createUpdateAuction = {
                ...this.state.createUpdateAuction,
                synchronizedStartTime: now.toString(),
                synchronizedCloseTime: now.toString()
            } as ICreateUpdateAuction;
            this.setState({
                ...this.state,
                createUpdateAuction,
                synchedStartTimeValue: toWallTime(now),
                synchedCloseTimeValue: toWallTime(now)
            });
        }

        // set up initial form on first load
        const auction = this.props.auctionDetail;
        if (!!auction && auction !== prevProps.auctionDetail) {
            const createUpdateAuction: ICreateUpdateAuction = {
                draftMode: auction.draftMode,
                name: auction.name || "",
                url: auction.url || "",
                isApprovalRequired: auction.isApprovalRequired,
                approvedAuctionBidderUserIds:
                    auction.approvedAuctionBidderUserIds,
                isSynchronized: auction.isSynchronized,
                synchronizedStartTime: auction.synchronizedStartTime || "",
                synchronizedCloseTime: auction.synchronizedCloseTime || "",
                isTest: auction.isTest
            };

            const startTimeValue = auction.isSynchronized
                ? this.toEditableWallTime(auction.synchronizedStartTime)
                : null;
            const closeTimeValue = auction.isSynchronized
                ? this.toEditableWallTime(auction.synchronizedCloseTime)
                : null;

            this.setState({
                createUpdateAuction,
                synchedStartTimeValue: startTimeValue,
                synchedCloseTimeValue: closeTimeValue
            });
        }
    }

    public render() {
        // redirect from new creates or deletes
        if (this.state.redirectUrl) {
            const editUrl = Constants.Routes.AdminAuctionDetail(
                this.state.submittedUrl
            );

            if (this.state.redirectUrl === editUrl) {
                window.location.assign(editUrl);
            } else {
                return <Redirect to={this.state.redirectUrl} />;
            }
        }

        // fullscreen loader when loading auction
        if (this.props.auctionDetailLoadState !== LoadState.Loaded) {
            return <FullscreenLoader />;
        }

        const classes = this.props.classes;

        const auction = this.props.auctionDetail;
        const auctionLive = !!auction && auction.isLive;
        const auctionClosed = !!auction && auction.isCompleted;

        const showTestMode = userHasRole(Roles.Developer)(this.props.user);

        const title = this.state.isCreate
            ? "Admin - Create New Sale"
            : `Admin - Manage "${auction?.name}"`;
        Constants.SetDocumentTitle(title);

        return (
            <Paper className={classes.paper} elevation={2}>
                <SectionBanner
                    leftSideText={title}
                    rightSideComponent={
                        <BannerButton
                            arrowLeft={true}
                            text="Back to Sales List"
                            link={this.backLink}
                        />
                    }
                />
                <div className={classes.section}>
                    <div className={classes.sectionContent}>
                        <Tabs
                            value={this.state.selectedTab}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.onTabChange}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Sale Details" />
                            <Tab label="Parcel Management" />
                            <Tab label="Parcel Order" />
                            {!this.state.isCreate && (
                                <Tab label="Approved Bidders" />
                            )}
                            {!this.state.isCreate && <Tab label="Reminders" />}
                            {!this.state.isCreate && <Tab label="Watchers" />}
                            {!this.state.isCreate && (
                                <Tab label="Saved Search Sends" />
                            )}
                        </Tabs>

                        {this.renderAuctionTab(
                            auctionLive,
                            auctionClosed,
                            showTestMode
                        )}
                        {this.renderParcelsTab(
                            auction,
                            auctionLive,
                            auctionClosed
                        )}
                        {this.renderParcelOrderTab(
                            auction,
                            auctionLive,
                            auctionClosed
                        )}
                        {this.state.selectedTab === 3 && auction?.auctionId && (
                            <ApprovedAuctionBiddersTab />
                        )}
                        {this.state.selectedTab === 4 && auction?.auctionId && (
                            <AuctionRemindersTab
                                auctionId={auction.auctionId}
                            />
                        )}
                        {this.state.selectedTab === 5 && auction?.auctionId && (
                            <AuctionWatchersTab auctionId={auction.auctionId} />
                        )}
                        {this.state.selectedTab === 6 && auction?.auctionId && (
                            <AuctionSavedSearchSendTab
                                auctionId={auction.auctionId}
                            />
                        )}
                    </div>
                </div>
            </Paper>
        );
    }

    private renderAuctionTab = (
        auctionLive: boolean,
        auctionClosed: boolean,
        showTestMode: boolean
    ) => {
        const classes = this.props.classes;

        const errors = this.props.savingAuctionErrors.concat(
            this.state.formErrors
        );
        // Simply hide the tab to prevent costly re-render of tiny MCE components
        return (
            <form
                className={`${classes.form} ${
                    this.state.selectedTab !== 0 ? classes.hidden : ""
                }`}
            >
                {/* Errors (if any) */}
                <div className={classes.formSection}>
                    <FormErrorWrapper
                        errors={errors.map((e) => e.description)}
                        errorMessage="The following errors occurred during save:"
                    />
                </div>

                {/* Notices */}
                <LiveClosedNotice
                    auctionLive={auctionLive}
                    auctionClosed={auctionClosed}
                />

                {/* Basic Info */}
                <div className={classes.formSection}>
                    <Grid container={true} spacing={2}>
                        <Grid item={true} xs={12}>
                            <WhiteTextTypography component="h6" variant="h6">
                                Basic Info
                            </WhiteTextTypography>
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={4}>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            <FormControlLabel
                                label="Draft Mode"
                                control={
                                    <Switch
                                        disabled={auctionLive}
                                        name="draftMode"
                                        checked={
                                            this.state.createUpdateAuction
                                                .draftMode
                                        }
                                        value="draftMode"
                                        onChange={this.onAuctionPropertyChange(
                                            true
                                        )}
                                        color="primary"
                                    />
                                }
                            />
                            <FormHelperText>
                                If draft mode is enabled, this sale will not
                                show on the main screen to bidders.
                            </FormHelperText>
                        </Grid>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            {this.state.createUpdateAuction.draftMode && (
                                <Typography
                                    component="h4"
                                    variant="h4"
                                    color="error"
                                    align="right"
                                >
                                    DRAFT
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={4}>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            <TextField
                                disabled={auctionLive}
                                margin="normal"
                                fullWidth={true}
                                required={true}
                                label="Sale Name"
                                name="name"
                                helperText="Maximum 30 characters."
                                autoFocus={true}
                                value={this.state.createUpdateAuction.name}
                                onChange={this.onNameChange}
                            />
                        </Grid>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            <TextField
                                disabled={auctionLive || auctionClosed}
                                margin="normal"
                                fullWidth={true}
                                required={true}
                                label="Sale URL"
                                name="url"
                                type="url"
                                helperText="Only letters, numbers, or dashes are allowed."
                                value={this.state.createUpdateAuction.url}
                                onChange={this.onUrlChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container={true}
                        spacing={4}
                        className={classes.formSyncedSection}
                    >
                        <Grid item={true} xs={12} sm={6} md={4}>
                            <DateTimePicker
                                disabled={auctionLive || auctionClosed}
                                error={!this.state.isSyncedStartTimeValid}
                                fullWidth={true}
                                helperText={
                                    this.state.syncedStartTimeSkippedMessage ??
                                    `Time currently shown in ${visitorTimeZone()}. Format: ${DateTimeLocalFormat}`
                                }
                                label="Synchronized Start Time"
                                margin="normal"
                                min={
                                    auctionLive || auctionClosed
                                        ? null
                                        : toWallTime(Temporal.Now.instant())
                                }
                                name="synchronizedStartTime"
                                onChange={this.onSyncedStartTimeChange}
                                required={true}
                                value={this.state.synchedStartTimeValue}
                            />
                        </Grid>
                        <Grid item={true} xs={12} sm={6} md={4}>
                            <DateTimePicker
                                disabled={auctionClosed}
                                error={!this.state.isSyncedCloseTimeValid}
                                fullWidth={true}
                                helperText={
                                    this.state.syncedCloseTimeSkippedMessage ??
                                    `Time currently shown in ${visitorTimeZone()}. Format: ${DateTimeLocalFormat}`
                                }
                                label="Synchronized End Time"
                                margin="normal"
                                min={
                                    this.state.synchedStartTimeValue ??
                                    toWallTime(Temporal.Now.instant())
                                }
                                name="synchronizedCloseTime"
                                onChange={this.onSyncedCloseTimeChange}
                                required={true}
                                value={this.state.synchedCloseTimeValue}
                            />
                        </Grid>
                        {showTestMode && (
                            <Grid item={true} xs={12} sm={12} md={6}>
                                <FormControlLabel
                                    label="Test Mode"
                                    control={
                                        <Switch
                                            disabled={auctionLive}
                                            name="isTest"
                                            checked={
                                                this.state.createUpdateAuction
                                                    .isTest
                                            }
                                            value="isTest"
                                            onChange={this.onAuctionPropertyChange(
                                                true
                                            )}
                                            color="primary"
                                        />
                                    }
                                />
                                <FormHelperText>
                                    If test mode is enabled, this sale will be
                                    only visible to developers.
                                </FormHelperText>
                            </Grid>
                        )}
                    </Grid>
                </div>

                {/* Submit */}
                <div className={classes.formSection}>
                    <Grid container={true} spacing={2}>
                        <Grid item={true} xs={12}>
                            {!auctionLive && (
                                <LoaderButton
                                    loading={this.props.savingAuction}
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.onFormSave}
                                >
                                    <Save />
                                    &nbsp;
                                    {this.state.isCreate ? "Create" : "Update"}
                                </LoaderButton>
                            )}
                            {!this.state.isCreate &&
                                this.props.auctionDetail && (
                                    <Button
                                        className={
                                            !auctionLive
                                                ? classes.viewBiddingButton
                                                : undefined
                                        }
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        href={Constants.Routes.Parcels(
                                            this.props.auctionDetail.url
                                        )}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <OpenInNew />
                                        &nbsp;View Bidding
                                    </Button>
                                )}
                            {!auctionLive && !this.state.isCreate && (
                                <LoaderButton
                                    className={classes.deleteButton}
                                    loading={this.props.savingAuction}
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.onFormDelete}
                                >
                                    <Delete />
                                    &nbsp;Delete
                                </LoaderButton>
                            )}
                        </Grid>

                        <Grid item={true} xs={6}>
                            <div className={classes.auditWrapper}></div>
                        </Grid>
                    </Grid>
                </div>

                {/* Audit Timestamps */}
                <div className={classes.formSection}>
                    <Grid container={true} spacing={2}>
                        {!this.state.isCreate && this.props.auctionDetail && (
                            <Grid item={true} xs={12}>
                                <div className={classes.auditWrapper}>
                                    <AuditTimestamps
                                        createdBy={
                                            this.props.auctionDetail.createdBy
                                        }
                                        createdOn={
                                            this.props.auctionDetail.createdOn
                                        }
                                        modifiedBy={
                                            this.props.auctionDetail.modifiedBy
                                        }
                                        modifiedOn={
                                            this.props.auctionDetail.modifiedOn
                                        }
                                    />
                                </div>
                            </Grid>
                        )}
                    </Grid>
                    <Divider className={classes.divider} />
                </div>
            </form>
        );
    };

    private renderParcelsTab = (
        auction: IAuctionDetail | null,
        auctionLive: boolean,
        auctionClosed: boolean
    ) => {
        const classes = this.props.classes;

        // Don't bother rendering if the tab is not visible
        if (this.state.selectedTab !== 1) {
            return null;
        }

        const lastRegularParcelCloseDateTime =
            this.getLastRegularParcelCloseDateTimeOrDefault();

        return (
            <form className={classes.form}>
                <div className={classes.formSection} />

                {/* Notices */}
                <LiveClosedNotice
                    auctionLive={auctionLive}
                    auctionClosed={auctionClosed}
                />

                {/* Iterated Parcels */}
                <div className={classes.formSection}>
                    <Grid container={true} spacing={2}>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            <WhiteTextTypography component="h6" variant="h6">
                                Parcels
                            </WhiteTextTypography>
                        </Grid>
                        {!this.state.isCreate &&
                            this.props.parcelsLoadState === LoadState.Loaded &&
                            !auctionLive &&
                            !auctionClosed && (
                                <Grid item={true} xs={12} sm={12} md={6}>
                                    <Button
                                        className={classes.buttonCreateNew}
                                        variant="outlined"
                                        onClick={this.onParcelCreateClick}
                                    >
                                        <AddCircleOutline />
                                        &nbsp;Create New
                                    </Button>
                                </Grid>
                            )}
                    </Grid>

                    {this.state.isCreate && (
                        <Grid container={true} spacing={4}>
                            <Grid item={true} xs={12}>
                                <WhiteTextTypography
                                    component="div"
                                    variant="body2"
                                    align="center"
                                    color="textSecondary"
                                >
                                    You must save the sale first before creating
                                    new parcels.
                                </WhiteTextTypography>
                            </Grid>
                        </Grid>
                    )}

                    {!this.state.isCreate &&
                        this.props.parcelsLoadState === LoadState.Loading && (
                            <Grid container={true} spacing={4}>
                                <Grid item={true} xs={12}>
                                    <div
                                        className={classes.parcelLoaderWrapper}
                                    >
                                        <CircularProgress
                                            className={classes.parcelLoader}
                                            color="secondary"
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        )}

                    {!this.state.isCreate &&
                        this.props.parcelsLoadState === LoadState.Loaded &&
                        this.props.parcels.length === 0 &&
                        !this.state.newParcel && (
                            <Grid container={true} spacing={4}>
                                <Grid item={true} xs={12}>
                                    <WhiteTextTypography
                                        component="div"
                                        variant="body2"
                                        align="center"
                                        color="textSecondary"
                                    >
                                        No parcels to display for the sale.
                                    </WhiteTextTypography>
                                </Grid>
                            </Grid>
                        )}

                    {!this.state.isCreate &&
                        this.props.parcelsLoadState === LoadState.Loaded &&
                        auction &&
                        this.props.parcels.map((parcel) => (
                            <ParcelEditContainer
                                key={parcel.parcelId}
                                auction={auction}
                                parcel={parcel}
                                parcelIndex={null}
                                onFileDelete={this.onDeleteFile}
                                onFileReorder={this.onReorderFile}
                                onFileUpload={this.onFileUpload}
                                onParcelCreate={this.props.createParcel}
                                onParcelDelete={this.props.deleteParcel}
                                onParcelRemoveClick={this.onParcelRemoveClick}
                                onParcelUpdate={this.props.updateParcel}
                                onParcelArchive={this.onParcelArchived}
                                resetParcelSaveErrors={() =>
                                    this.props.resetParcelSaveErrors(
                                        parcel.parcelId
                                    )
                                }
                                savingNewParcel={this.props.savingNewParcel}
                                savingNewParcelErrors={
                                    this.props.savingNewParcelErrors
                                }
                                url={this.props.match.params.url}
                                lastRegularParcelCloseDateTime={lastRegularParcelCloseDateTime.toString()}
                            />
                        ))}

                    {!this.state.isCreate &&
                        this.props.parcelsLoadState === LoadState.Loaded &&
                        this.state.newParcel &&
                        auction && (
                            <ParcelEditContainer
                                auction={auction}
                                parcel={null}
                                parcelIndex={this.props.parcels.length + 1}
                                onFileDelete={this.onDeleteFile}
                                onFileReorder={this.onReorderFile}
                                onFileUpload={this.onFileUpload}
                                onParcelCreate={this.props.createParcel}
                                onParcelDelete={this.props.deleteParcel}
                                onParcelRemoveClick={this.onParcelRemoveClick}
                                onParcelUpdate={this.props.updateParcel}
                                onParcelArchive={this.onParcelArchived}
                                resetParcelSaveErrors={() => {
                                    /* Do nothing */
                                }}
                                savingNewParcel={this.props.savingNewParcel}
                                savingNewParcelErrors={
                                    this.props.savingNewParcelErrors
                                }
                                url={this.props.match.params.url}
                                lastRegularParcelCloseDateTime={lastRegularParcelCloseDateTime.toString()}
                            />
                        )}
                </div>
            </form>
        );
    };

    private renderParcelOrderTab = (
        auction: IAuctionDetail | null,
        auctionLive: boolean,
        auctionClosed: boolean
    ) => {
        const classes = this.props.classes;

        // Don't bother rendering if the tab is not visible
        if (this.state.selectedTab !== 2) {
            return null;
        }

        return (
            <form className={classes.form}>
                <div className={classes.formSection} />

                {/* Notices */}
                <LiveClosedNotice
                    auctionLive={auctionLive}
                    auctionClosed={auctionClosed}
                />

                {/* Interated Parcels */}
                <div className={classes.formSection}>
                    <Grid container={true} spacing={2}>
                        <Grid item={true} xs={12} sm={12} md={6}>
                            <WhiteTextTypography component="h6" variant="h6">
                                Parcels
                            </WhiteTextTypography>
                        </Grid>
                    </Grid>

                    {this.state.isCreate && (
                        <Grid container={true} spacing={4}>
                            <Grid item={true} xs={12}>
                                <WhiteTextTypography
                                    component="div"
                                    variant="body2"
                                    align="center"
                                    color="textSecondary"
                                >
                                    You must save the sale and parcels before
                                    using this functionality.
                                </WhiteTextTypography>
                            </Grid>
                        </Grid>
                    )}
                    {this.state.newParcel && (
                        <Grid container={true} spacing={4}>
                            <Grid item={true} xs={12}>
                                <WhiteTextTypography
                                    component="div"
                                    variant="body2"
                                    align="center"
                                    color="textSecondary"
                                >
                                    You must create parcels before using this
                                    functionality.
                                </WhiteTextTypography>
                            </Grid>
                        </Grid>
                    )}

                    {!this.state.isCreate &&
                        !this.state.newParcel &&
                        this.props.parcelsLoadState === LoadState.Loading && (
                            <Grid container={true} spacing={4}>
                                <Grid item={true} xs={12}>
                                    <div
                                        className={classes.parcelLoaderWrapper}
                                    >
                                        <CircularProgress
                                            className={classes.parcelLoader}
                                            color="secondary"
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        )}

                    {!this.state.isCreate &&
                        !this.state.newParcel &&
                        this.props.parcelsLoadState === LoadState.Loaded &&
                        this.props.parcels.length === 0 && (
                            <Grid container={true} spacing={4}>
                                <Grid item={true} xs={12}>
                                    <WhiteTextTypography
                                        component="div"
                                        variant="body2"
                                        align="center"
                                        color="textSecondary"
                                    >
                                        You must create parcels before using
                                        this functionality.
                                    </WhiteTextTypography>
                                </Grid>
                            </Grid>
                        )}

                    {!this.state.isCreate &&
                        !this.state.newParcel &&
                        this.props.parcelsLoadState === LoadState.Loaded &&
                        auction &&
                        this.props.parcels.length > 0 && (
                            <ParcelsOrderRow auction={auction} />
                        )}
                </div>
            </form>
        );
    };

    private onTabChange = (e: React.ChangeEvent<{}>, value: number) => {
        this.setState({ selectedTab: value });
        this.props.history.replace({
            ...this.props.location,
            search: withSaleDetailsTab(this.props.location.search, value)
        });
    };

    private onParcelArchived = (parcelId: string, isArchiving: boolean) => {
        this.props.archiveParcel(parcelId, isArchiving);
        const parcelCount = this.props.parcels.length;
        if (parcelCount === 1) {
            this.setState({
                ...this.state,
                createUpdateAuction: {
                    ...this.state.createUpdateAuction,
                    draftMode: true
                }
            });
        }
    };

    private onSyncedStartTimeChange = (
        value: Temporal.PlainDateTime | null,
        isValid: boolean
    ) => {
        if (!isValid) {
            this.setState({ isSyncedStartTimeValid: false });
            return;
        }

        if (!value) {
            this.setState((s) => ({
                createUpdateAuction: {
                    ...s.createUpdateAuction,
                    synchronizedStartTime: ""
                } as ICreateUpdateAuction,
                synchedStartTimeValue: null,
                isSyncedStartTimeValid: true,
                syncedStartTimeSkippedMessage: null
            }));
            return;
        }

        const instant = toInstant(value);
        if (!instant) {
            this.setState({
                isSyncedStartTimeValid: false,
                syncedStartTimeSkippedMessage: skippedOrRepeatedTimeMessage()
            });
            return;
        }

        this.setState((s) => {
            const isCloseValid =
                !s.syncedCloseTimeSkippedMessage &&
                (!s.synchedCloseTimeValue ||
                    Temporal.PlainDateTime.compare(
                        s.synchedCloseTimeValue,
                        value
                    ) >= 0);

            return {
                createUpdateAuction: {
                    ...s.createUpdateAuction,
                    synchronizedStartTime: instant.toString()
                } as ICreateUpdateAuction,
                synchedStartTimeValue: value,
                isSyncedStartTimeValid: true,
                isSyncedCloseTimeValid: isCloseValid,
                syncedStartTimeSkippedMessage: null
            };
        });
    };

    private onSyncedCloseTimeChange = (
        value: Temporal.PlainDateTime | null,
        isValid: boolean
    ) => {
        if (!isValid) {
            this.setState({ isSyncedCloseTimeValid: false });
            return;
        }

        if (!value) {
            this.setState((s) => ({
                createUpdateAuction: {
                    ...s.createUpdateAuction,
                    synchronizedCloseTime: ""
                } as ICreateUpdateAuction,
                synchedCloseTimeValue: null,
                isSyncedCloseTimeValid: true,
                syncedCloseTimeSkippedMessage: null
            }));
            return;
        }

        const instant = toInstant(value);
        if (!instant) {
            this.setState({
                isSyncedCloseTimeValid: false,
                syncedCloseTimeSkippedMessage: skippedOrRepeatedTimeMessage()
            });
            return;
        }

        this.setState((s) => {
            const isValid =
                !s.synchedStartTimeValue ||
                Temporal.PlainDateTime.compare(
                    value,
                    s.synchedStartTimeValue
                ) >= 0;

            return {
                createUpdateAuction: {
                    ...s.createUpdateAuction,
                    synchronizedCloseTime: instant.toString()
                } as ICreateUpdateAuction,
                synchedCloseTimeValue: value,
                isSyncedCloseTimeValid: isValid,
                syncedCloseTimeSkippedMessage: null
            };
        });
    };

    private onNameChange = (event: ChangeEvent<HTMLInputElement>) => {
        const name = event.target.value;
        const url = this.state.urlManuallyEdited ? {} : { url: slugify(name) };
        const createUpdateAuction: ICreateUpdateAuction = {
            ...this.state.createUpdateAuction,
            name,
            ...url
        };

        this.setState({ createUpdateAuction });
    };

    private onUrlChange = (event: ChangeEvent<HTMLInputElement>) => {
        const createUpdateAuction: ICreateUpdateAuction = {
            ...this.state.createUpdateAuction,
            url: event.target.value
        };

        this.setState({ createUpdateAuction, urlManuallyEdited: true });
    };

    private onAuctionPropertyChange =
        (isCheckbox = false) =>
        (event: ChangeEvent<HTMLInputElement>) => {
            const name = event.target.name;
            const value = isCheckbox
                ? (event.target.checked as boolean)
                : (event.target.value as string);

            const createUpdateAuction = {
                ...this.state.createUpdateAuction,
                [name]: value
            } as ICreateUpdateAuction;

            this.setState({ createUpdateAuction });
        };

    private onParcelCreateClick = (e: React.MouseEvent) => {
        e.preventDefault();

        if (!this.state.newParcel) {
            this.setState({ newParcel: true });
            $("body, html").animate(
                {
                    scrollTop:
                        ($(document).height() ?? 0) - ($(window).height() ?? 0)
                },
                Constants.ScrollAnimationLength
            );
        }
    };

    private onParcelRemoveClick = () => this.setState({ newParcel: false });

    private validateForm = () => {
        this.setState({ formErrors: [] });
        const formErrors: IErrorInfo[] = [];
        const requiredMessage = "field is required.";
        const { createUpdateAuction, isAuctionDateValid } = this.state;
        const addError = (code: string, description: string) => {
            formErrors.push({ code, description } as IErrorInfo);
        };

        if (!createUpdateAuction.name) {
            addError("EMPTY_AUCTION_NAME", "Auction name " + requiredMessage);
        }

        if (!createUpdateAuction.url) {
            addError("EMPTY_AUCTION_URL", "Auction URL " + requiredMessage);
        }

        if (!isAuctionDateValid) {
            addError(
                "INVALID_AUCTION_DATE",
                `Invalid sale date. Date should be in ${DateTimeLocalFormat} format.`
            );
        }

        if (createUpdateAuction.isSynchronized) {
            if (!createUpdateAuction.synchronizedStartTime) {
                addError(
                    "EMPTY_SYNCED_START_DATE",
                    "Synchronized Start Time " + requiredMessage
                );
            }

            if (!createUpdateAuction.synchronizedCloseTime) {
                addError(
                    "EMPTY_SYNCED_CLOSE_DATE",
                    "Synchronized Closed Time " + requiredMessage
                );
            }
        }

        this.setState({ formErrors });

        return formErrors.length === 0; //if valid
    };

    private onFormSave = (e: React.MouseEvent) => {
        e.preventDefault();
        if (this.validateForm()) {
            // The URL field stays editable while saving, so remember what was submitted
            this.setState({ submittedUrl: this.state.createUpdateAuction.url });
            if (this.state.isCreate) {
                this.props.createAuction(this.state.createUpdateAuction);
            } else {
                this.props.updateAuction(this.state.createUpdateAuction);
            }
        }
    };

    private onFormDelete = (e: React.MouseEvent) => {
        e.preventDefault();

        if (
            this.props.auctionDetail &&
            window.confirm(
                "Deleting the sale will also delete all child parcel records. Are you sure you would like to continue?"
            )
        ) {
            this.setState({ deleteClicked: true });
            this.props.deleteAuction(this.props.auctionDetail.auctionId);
        }
    };

    private openErrorSnackbar = () =>
        enqueueSnackbar("Sale successfully deleted", {
            anchorOrigin: { horizontal: "left", vertical: "top" },
            preventDuplicate: false,
            variant: "error"
        });

    private openSuccessSnackbar = () =>
        enqueueSnackbar("Sale successfully saved", {
            anchorOrigin: { horizontal: "left", vertical: "top" },
            preventDuplicate: false,
            variant: "success"
        });

    private onDeleteFile =
        (
            entityId: string,
            fileType: FileType,
            setErrorState: (errors: IErrorInfo[]) => void,
            calledFromFileUpload = false
        ) =>
        (fileName: string) =>
        async (): Promise<IErrorInfo[]> => {
            const deleteFn = async () => {
                this.toggleMetadataLoadState(
                    entityId,
                    fileType,
                    LoadState.Loading
                );

                const errors = await FileApi.DeleteFile(
                    entityId,
                    fileType,
                    fileName
                );
                if (errors.length > 0) {
                    setErrorState(errors);
                    return errors;
                } else {
                    // if called from upload, refresh happens in there
                    if (!calledFromFileUpload) {
                        this.refreshFileMetadata(entityId, fileType);
                    }
                }

                return [];
            };

            // only ask delete confirmation if not overwriting
            if (!calledFromFileUpload) {
                if (
                    window.confirm(
                        "Are you sure you would like to delete this file? This action cannot be undone."
                    )
                ) {
                    return await deleteFn();
                }
            } else {
                return await deleteFn();
            }

            return [];
        };

    private onFileUpload =
        (
            entityId: string,
            fileType: FileType,
            setErrorState: (errors: IErrorInfo[]) => void
        ) =>
        async (files: File[]): Promise<IErrorInfo[]> => {
            const uploadFn = async () => {
                const uploadResponse = await FileApi.UploadFile(
                    entityId,
                    fileType,
                    files
                );
                if (uploadResponse.ErrorInfo.length === 0) {
                    this.refreshFileMetadata(entityId, fileType);
                }

                return uploadResponse.ErrorInfo;
            };

            const cancelledFn = () => [
                {
                    code: "Error_Cancelled",
                    description: "User cancelled the upload."
                } as IErrorInfo
            ];
            const deleteFn = async (existingPic: IFileMetadata) =>
                await this.onDeleteFile(
                    entityId,
                    fileType,
                    setErrorState,
                    true
                )(existingPic.fileName)();

            // Certain file types can only have one file exist in the store; for these types, an overwrite occurs.
            // Prompt user asking for overwrite confirm if a file exists for the type already.
            switch (fileType) {
                case FileType.AuctionHomePicture:
                    return await this.singleFileUpload(
                        this.props.auctionDetail?.homePictureMetadata ?? null,
                        "Uploading will overwrite the existing home picture. Would you like to continue?",
                        uploadFn,
                        cancelledFn,
                        deleteFn
                    );

                case FileType.AuctionMap:
                    return await this.singleFileUpload(
                        this.props.auctionDetail?.mapMetadata ?? null,
                        "Uploading will overwrite the existing map picture. Would you like to continue?",
                        uploadFn,
                        cancelledFn,
                        deleteFn
                    );

                default:
                    return await uploadFn();
            }
        };

    private onReorderFile =
        (entityId: string, fileType: FileType) =>
        (fileName: string, newIndex: number) =>
        async (): Promise<IErrorInfo[]> => {
            this.toggleMetadataLoadState(entityId, fileType, LoadState.Loading);

            await FileApi.ReorderFile(entityId, fileType, fileName, newIndex);
            this.refreshFileMetadata(entityId, fileType);

            return [];
        };

    private singleFileUpload = async (
        existingFile: IFileMetadata | null,
        confirmText: string,
        uploadFn: () => Promise<IErrorInfo[]>,
        cancelledFn: () => IErrorInfo[],
        deleteFn: (existingPic: IFileMetadata) => Promise<IErrorInfo[]>
    ): Promise<IErrorInfo[]> => {
        if (!existingFile) {
            return await uploadFn();
        }

        if (window.confirm(confirmText)) {
            const errors = await deleteFn(existingFile);
            if (errors.length > 0) {
                return errors;
            }
            return await uploadFn();
        }
        return cancelledFn();
    };

    private refreshFileMetadata = (entityId: string, fileType: FileType) => {
        switch (fileType) {
            case FileType.AuctionHomePicture:
            case FileType.AuctionMap:
            case FileType.AuctionPicture:
                this.props.refreshAuctionFileMetadata(fileType);
                break;

            case FileType.ParcelCustom:
            case FileType.ParcelLandTitle:
            case FileType.ParcelPicture:
            case FileType.ParcelPurchaseAgreement:
                this.props.refreshParcelFileMetadata(entityId, fileType);
                break;

            default:
                break;
        }
    };

    private toggleMetadataLoadState = (
        entityId: string,
        fileType: FileType,
        loadState: LoadState
    ) => {
        switch (fileType) {
            case FileType.AuctionHomePicture:
            case FileType.AuctionMap:
            case FileType.AuctionPicture:
                this.props.toggleAuctionMetadataLoadState(fileType, loadState);
                break;

            case FileType.ParcelCustom:
            case FileType.ParcelLandTitle:
            case FileType.ParcelPicture:
            case FileType.ParcelPurchaseAgreement:
                this.props.toggleParcelMetadataLoadState(
                    entityId,
                    fileType,
                    loadState
                );
                break;

            default:
                break;
        }
    };

    private backLink = (props: Partial<LinkProps>) => (
        <Link to={Constants.Routes.AdminAuctionList()} {...props} />
    );

    private toEditableWallTime = (isoString: string | null | undefined) => {
        const instant = parseAuctionInstant(isoString);
        return instant ? toWallTime(instant) : null;
    };

    private getLastRegularParcelCloseDateTimeOrDefault =
        (): Temporal.Instant => {
            const regularParcels = this.props.parcels.filter((p) => !p.enBloc);

            const lastClose = regularParcels.reduce<Temporal.Instant | null>(
                (latest, parcel) => {
                    const closeInstant = parseAuctionInstant(
                        parcel.auctionEndDate
                    );
                    if (!closeInstant) return latest;
                    return !latest ||
                        Temporal.Instant.compare(closeInstant, latest) > 0
                        ? closeInstant
                        : latest;
                },
                null
            );

            return lastClose ?? Temporal.Now.instant();
        };
}

const reduxState = (state: IAppState) =>
    Object.assign(
        {},
        state.auctionStoreState,
        state.parcelStoreState,
        state.userStoreState,
        state.appConfigStoreState
    );
const reduxDispatch = (dispatch: IAppDispatch) =>
    bindActionCreators(
        Object.assign(
            {},
            AuctionStore.actionCreators,
            ParcelStore.actionCreators,
            UserStore.actionCreators
        ),
        dispatch
    );

export default withStyles(styles)(
    connect(reduxState, reduxDispatch)(ManageAuctionDetails)
);
